export const AB_TESTS_TYPE_MAIN = 'MAIN'
export const AB_TESTS_TYPE_AI = 'AI_VARIANT'
export const AB_TESTS_TYPE_COMPARE = 'COMPARE'

export const STATUS_UNDEFINED = 'UNDEFINED'
export const STATUS_NONE = 'NONE'
export const STATUS_PENDING = 'PENDING'
export const STATUS_DONE = 'DONE'
